import tmhRequest from '@/config/tmhRequest'

export default {
    searchRefundRechargeOrderReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/refundrechargeorderreport/searchrefundrechargeorderreportcount',
            method: 'post',
            data: data,
        })
    },
    searchRefundRechargeOrderReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/refundrechargeorderreport/searchrefundrechargeorderreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportRefundRechargeOrderReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/refundrechargeorderreport/exportrefundrechargeorderreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/refundrechargeorderreport.js